/**
 * Table component.
 * @module components/table
 */

const table = {

	$window: $(window),

	elem: {
		$user: $('.user-markup table'),
		$table: $('.table')
	},

	// init(): wrap all tables in a <div> and call overscroll behavior
	init() {
		if ( this.elem.$user.length > 0) {
			this.elem.$user.wrap('<div class="table"></div>');
			this.elem.$table = $('.table');
		}

		if (this.elem.$table.length > 0) {
			$(window).on('resize', this.overscroll.bind(this));
			this.overscroll();			
		}
	},

	// overscroll(): when a table is wider than its container, add the class which enables overscroll behavior
	overscroll() {
		this.elem.$table.each(function() {
			$(this).removeClass('table--overscroll');
			if($(this).find('table').width() > $(this).width()) {
				$(this).addClass('table--overscroll');
			}
		});
	}

};

export { table };
